import type { DualTheme, Theme } from '../types';

// packages/lyric-stage/src/theme/baseThemes.ts
// Built-in light/dark presets before AI or custom themes exist.

export const DEFAULT_THEME: Theme = {
  name: 'Midnight Default',
  backgroundColor: '#09090b',
  primaryColor: '#f4f4f5',
  accentColor: '#f4f4f5',
  secondaryColor: '#71717a',
  fontStyle: 'sans',
  animationIntensity: 'normal',
};

export const DAYLIGHT_THEME: Theme = {
  name: 'Daylight Default',
  backgroundColor: '#f5f5f4',
  primaryColor: '#1c1917',
  accentColor: '#ea580c',
  secondaryColor: '#44403c',
  fontStyle: 'sans',
  animationIntensity: 'normal',
};

export const BASE_DUAL_THEME: DualTheme = {
  light: DAYLIGHT_THEME,
  dark: DEFAULT_THEME,
};
